import { render, staticRenderFns } from "./ModalDeleteAugmentation.vue?vue&type=template&id=78e800e2&scoped=true&"
import script from "./ModalDeleteAugmentation.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteAugmentation.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteAugmentation.vue?vue&type=style&index=0&id=78e800e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e800e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
